export const onCreateQuiz = /* GraphQL */ `
  subscription onCreateQuiz($filter: ModelSubscriptionQuizFilterInput, $ownerIdAndWsId: String) {
  onCreateQuiz(filter: $filter, ownerIdAndWsId: $ownerIdAndWsId) {
      createdAt
      creator
      description
      id
      latestEditor
      meta
      name
      ownerIdAndWsId
      publication_state
      questionsCount
      questionsOrder
      relatedPages
      requiredPassPercentage
      stats
      updatedAt
      version
  }
}
`;

export const onCreateQuizAnswer = /* GraphQL */ `
  subscription onCreateQuizAnswer($filter: ModelSubscriptionQuizAnswerFilterInput, $ownerIdAndWsId: String) {
  onCreateQuizAnswer(filter: $filter, ownerIdAndWsId: $ownerIdAndWsId) {
      answers
      attempt
      completedAt
      duration
      id
      ownerIdAndWsId
      quizAndUserId
      quizId
      score
      status
      userId
  }
}
`;

export const onCreateQuizQuestion = /* GraphQL */ `
  subscription onCreateQuizQuestion($filter: ModelSubscriptionQuizQuestionFilterInput, $ownerIdAndWsId: String) {
  onCreateQuizQuestion(filter: $filter, ownerIdAndWsId: $ownerIdAndWsId) {
      id
      options
      ownerIdAndWsId
      quizId
      text
      version
  }
}
`;

export const onCreateQuizStats = /* GraphQL */ `
  subscription onCreateQuizStats($filter: ModelSubscriptionQuizStatsFilterInput, $ownerIdAndWsId: String) {
  onCreateQuizStats(filter: $filter, ownerIdAndWsId: $ownerIdAndWsId) {
      answerId
      attempt
      completePercentage
      completedAt
      id
      ownerIdAndWsId
      quizAndUserId
      quizId
      score
      status
      userId
      userIdAndStatus
  }
}
`;

export const onDeleteQuiz = /* GraphQL */ `
  subscription onDeleteQuiz($filter: ModelSubscriptionQuizFilterInput, $ownerIdAndWsId: String) {
  onDeleteQuiz(filter: $filter, ownerIdAndWsId: $ownerIdAndWsId) {
      createdAt
      creator
      description
      id
      latestEditor
      meta
      name
      ownerIdAndWsId
      publication_state
      questionsCount
      questionsOrder
      relatedPages
      requiredPassPercentage
      stats
      updatedAt
      version
  }
}
`;

export const onDeleteQuizAnswer = /* GraphQL */ `
  subscription onDeleteQuizAnswer($filter: ModelSubscriptionQuizAnswerFilterInput, $ownerIdAndWsId: String) {
  onDeleteQuizAnswer(filter: $filter, ownerIdAndWsId: $ownerIdAndWsId) {
      answers
      attempt
      completedAt
      duration
      id
      ownerIdAndWsId
      quizAndUserId
      quizId
      score
      status
      userId
  }
}
`;

export const onDeleteQuizQuestion = /* GraphQL */ `
  subscription onDeleteQuizQuestion($filter: ModelSubscriptionQuizQuestionFilterInput, $ownerIdAndWsId: String) {
  onDeleteQuizQuestion(filter: $filter, ownerIdAndWsId: $ownerIdAndWsId) {
      id
      options
      ownerIdAndWsId
      quizId
      text
      version
  }
}
`;

export const onDeleteQuizStats = /* GraphQL */ `
  subscription onDeleteQuizStats($filter: ModelSubscriptionQuizStatsFilterInput, $ownerIdAndWsId: String) {
  onDeleteQuizStats(filter: $filter, ownerIdAndWsId: $ownerIdAndWsId) {
      answerId
      attempt
      completePercentage
      completedAt
      id
      ownerIdAndWsId
      quizAndUserId
      quizId
      score
      status
      userId
      userIdAndStatus
  }
}
`;

export const onUpdateQuiz = /* GraphQL */ `
  subscription onUpdateQuiz($filter: ModelSubscriptionQuizFilterInput, $ownerIdAndWsId: String) {
  onUpdateQuiz(filter: $filter, ownerIdAndWsId: $ownerIdAndWsId) {
      createdAt
      creator
      description
      id
      latestEditor
      meta
      name
      ownerIdAndWsId
      publication_state
      questionsCount
      questionsOrder
      relatedPages
      requiredPassPercentage
      stats
      updatedAt
      version
  }
}
`;

export const onUpdateQuizAnswer = /* GraphQL */ `
  subscription onUpdateQuizAnswer($filter: ModelSubscriptionQuizAnswerFilterInput, $ownerIdAndWsId: String) {
  onUpdateQuizAnswer(filter: $filter, ownerIdAndWsId: $ownerIdAndWsId) {
      answers
      attempt
      completedAt
      duration
      id
      ownerIdAndWsId
      quizAndUserId
      quizId
      score
      status
      userId
  }
}
`;

export const onUpdateQuizQuestion = /* GraphQL */ `
  subscription onUpdateQuizQuestion($filter: ModelSubscriptionQuizQuestionFilterInput, $ownerIdAndWsId: String) {
  onUpdateQuizQuestion(filter: $filter, ownerIdAndWsId: $ownerIdAndWsId) {
      id
      options
      ownerIdAndWsId
      quizId
      text
      version
  }
}
`;

export const onUpdateQuizStats = /* GraphQL */ `
  subscription onUpdateQuizStats($filter: ModelSubscriptionQuizStatsFilterInput, $ownerIdAndWsId: String) {
  onUpdateQuizStats(filter: $filter, ownerIdAndWsId: $ownerIdAndWsId) {
      answerId
      attempt
      completePercentage
      completedAt
      id
      ownerIdAndWsId
      quizAndUserId
      quizId
      score
      status
      userId
      userIdAndStatus
  }
}
`;
